import React, { PropsWithChildren } from "react";
import classes from "./Modal.module.css";
import { Button } from "@mui/material";

interface Props {
    open: boolean;
    // setOpen: (value: boolean) => void;
    title: string;
    onSubmit?: any;
    onClose: () => void;
    // children: ReactNode;
    className?: string;
}

const Modal = ({ open, onSubmit, onClose, title, children, className }: PropsWithChildren<Props>) => {
    // useEffect(() => {
    //     open && (document.body.style.overflow = "hidden");
    //     return () => {
    //         document.body.style.overflow = "";
    //     };
    // }, [open]);
    if (!open) {
        return null;
    }
    return (
        <div className={`${classes.modal} ${className || ""}`}>
            <div className={classes.modal__content} onClick={e => e.stopPropagation()}>
                <div className={classes.modal__header}>
                    <div className={classes.modal__title}>{title}</div>
                </div>
                <div className={classes.modal__body}>{children}</div>
                <div className={classes.modal__footer}>
                    {onSubmit ? (
                        <Button
                            variant="outlined"
                            type="button"
                            // className={classes.btn}
                            onClick={onSubmit}>
                            Подтвердить
                        </Button>
                    ) : (
                        <div />
                    )}
                    <Button
                        variant="outlined"
                        type="button"
                        // className={classes.btn}
                        onClick={onClose}>
                        Отмена
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
